/* Register your structure. A table for the verdicts because each row is a line, a name, a result and
   a reason, read across; the counts above it are the shape Bulk edit's are. */

.actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin: 10px 0;
}

.rules {
  margin: 0 0 12px;
  padding-left: 18px;
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--muted);
}

.rules li + li {
  margin-top: 4px;
}

.counts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px 0;
}

.count {
  display: flex;
  flex-direction: column;
  min-width: 120px;
  padding: 8px 10px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--panel-2);
  font-size: var(--t-min);
}

.countLabel {
  font-weight: 600;
}

/* A refusal is the thing to act on, so it is the one number that changes colour. */
.refusedCount {
  color: var(--crit);
  font-weight: 600;
}

.warning {
  margin: 0 0 12px;
  padding: 8px 10px;
  font-size: var(--t-min);
  line-height: 1.5;
  border: 1px solid var(--warn-line);
  border-radius: 8px;
  background: var(--warn-w);
}

.rows {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--t-min);
}

.rows th,
.rows td {
  padding: 6px 8px;
  text-align: left;
  vertical-align: top;
  border-bottom: 1px solid var(--line);
}

.refusedRow {
  background: var(--crit-w);
}

.reasons {
  margin: 0;
  padding-left: 16px;
}

.remedy {
  color: var(--muted);
}
